import { render, staticRenderFns } from "./DevolucaoOrcardoVendedores.vue?vue&type=template&id=31c460d6&scoped=true&"
import script from "./DevolucaoOrcardoVendedores.vue?vue&type=script&lang=js&"
export * from "./DevolucaoOrcardoVendedores.vue?vue&type=script&lang=js&"
import style0 from "./DevolucaoOrcardoVendedores.vue?vue&type=style&index=0&id=31c460d6&scoped=true&lang=css&"
import style1 from "./DevolucaoOrcardoVendedores.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c460d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VRow})
